<template>
  <div class="container mt-2" id='app'>
    <!-- <div class="logo col-12">
      <img src="../public/hestia.jpeg" alt="Hestia">
    </div> -->
    <div class="iconos col-12">
      <img class="imgLogo" src="../public/hestia.jpeg" alt="HESTIA">
    </div>
    <div class="iconos col-12">
      <h3 class="title is-3">Auditorías de energía</h3>
      <img class="imgIconos" src="../public/icono-luz.png" alt="Electricidad">
      <img class="imgIconos" src="../public/icono-gas.png" alt="Gas">
    </div>
      <!--<Navbar />-->
      <mdb-navbar color="light-green lighten-4">
          <router-link to="/" v-if="existeUsuario" class="button is-info is-small mx-1">Home</router-link>
          <router-link to="/verificador" v-if="usuarioAdmin" class="button is-info is-small mx-1">Admin</router-link>
          <router-link to="/registro" v-if="usuarioAdmin" class="button is-info is-small mx-1">Registrar Usuario</router-link>
          <router-link to="/acceso" v-if="!existeUsuario && !vistaAcceso" class="button is-info is-small mx-1">Acceder</router-link>
          <button @click="cerrarSesion" v-if="existeUsuario" class="button is-info is-small mx-1">Cerrar Sesión</button>
      </mdb-navbar>
    <router-view/>
    <Footer />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import { mdbNavbar, mdbFormInline} from 'mdbvue';
import Footer from "./components/Footer";
export default {
  methods:{
    ...mapActions(['cerrarSesion', 'editarAuditoria'])
  },
  computed:{
    ...mapGetters(['existeUsuario', 'usuarioAdmin']),
    ...mapState(["auditoria"]),
    vistaAcceso() {
     return this.$route.name === 'Acceso'
  }
  },
  components: {
      mdbNavbar,
      mdbFormInline,
      Footer
  },
}
</script>

<style scoped>
#app{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.iconos {
  margin-top: 30px;
}

.imgIconos {
  height: 80px;
  width: 80px;
}

.imgLogo{
  height: 200px;
  width: 250px;
}

nav {
  margin-bottom: 40px;
}

@media (max-width: 790px) {
  .btn {
    font-size: 0.80em;;
    padding:10px 11px;
  }

.imgIconos {
  height: 50px;
  width: 50px;
}

.imgLogo{
  height: 150px;
  width: 190px;
}
}

@media (max-width: 450px) {
  .btn {
    font-size: 0.80em;;
    padding:10px 11px;
  }
}

@media (max-width: 340px) {
  .btn {
    font-size: 0.80em;;
    padding:4px 6px;
  }

.imgIconos {
  height: 40px;
  width: 40px;
}

.imgLogo{
  height: 120px;
  width: 170px;
}
}
</style>